import { AvailableFeaturesDocument } from "~graphql/typed-document-nodes";
import { useQuery } from "~hooks/useQuery";

export const useAvailableFeatureFlags = (filter: string | undefined) => {
  const { data, error } = useQuery(AvailableFeaturesDocument);

  if (error) {
    console.error(`Failed to fetch available features: ${error.message}`);
  }

  const flags = data?.availableFeatures?.features || [];
  const normalisedFilter = filter?.toLowerCase();

  const filteredFlags = filter
    ? flags.filter((feature) => {
        return (
          feature.label.toLowerCase().includes(normalisedFilter || "") ||
          feature.description.toLowerCase().includes(normalisedFilter || "") ||
          feature.status.toLowerCase().includes(normalisedFilter || "")
        );
      })
    : flags;

  return filteredFlags;
};
